export const SUPPORTED_CAMPAIGN_CURRENCIES = ['USD', 'EUR'] as const;
export const DEFAULT_CAMPAIGN_CURRENCY = 'USD';

export function normalizeCampaignCurrency(value?: string | null): string {
  const normalizedValue = value?.toString?.().trim?.().toUpperCase?.() || '';
  return SUPPORTED_CAMPAIGN_CURRENCIES.includes(normalizedValue as typeof SUPPORTED_CAMPAIGN_CURRENCIES[number])
    ? normalizedValue
    : DEFAULT_CAMPAIGN_CURRENCY;
}

export function formatCampaignMoney(
  value: number | string,
  currencyCode: string = DEFAULT_CAMPAIGN_CURRENCY,
  options: { minimumFractionDigits?: number; maximumFractionDigits?: number } = {}
): string {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: normalizeCampaignCurrency(currencyCode),
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  }).format(safeValue);
}

export function formatCampaignRatePer1k(value: number | string, currencyCode?: string): string {
  return `${formatCampaignMoney(value, currencyCode)} / 1K`;
}
